import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App.jsx";
import { instalarShimStorage } from "./services/db/persistencia.js";
import "./styles/global.css";
/* Mínimo táctil y tablas anchas en las pantallas de carga de datos. */
import "./styles/ingresoDeDatos.css";

// Se instala antes de montar React: el prototipo lee window.storage durante
// su primer render, así que si el shim llega después, esa lectura se pierde.
instalarShimStorage();

const container = document.getElementById("root");

if (!container) {
  throw new Error("No se encontró #root en index.html — la app no puede montarse.");
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
